// extracted by mini-css-extract-plugin
export default {"select":"VersionSelect_select__1zDXj","queryText":"VersionSelect_queryText__1BcN6"};